<template>
  <div>
    <el-select :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.reason')" filterable clearable :multiple="multiple"
      :size="size" class="d-block">
      <el-option v-for="(reason,index) in reasons" :key="'reasons-' + index" :label="reason.name" :value="reason.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
        size: {
            default: 'small'
        },
        placeholder: {
            default: null,
        },
        id:{
          default: null
        },
        multiple:{
            type: Boolean,
            default: false,
        }
    },
     watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.reasons && this.reasons.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        reasons: 'reason/inventory'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'reason/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
